import React from 'react';

const ProgressBar = ({ progress, status, loading }) => {
  const progressBarStyle = {
    width: `${progress}%`,
    backgroundColor: '#4CAF50',
    height: '20px',
    borderRadius: '5px',
    transition: 'width 0.3s ease-in-out',
    position: 'relative'
  };

  return (
    <div style={{ marginBottom: '20px', border: '1px solid #ddd', padding: '15px', borderRadius: '8px' }}>
      <div style={{ marginBottom: '10px' }}>
        <strong>Status: </strong>
        <span style={{ color: loading ? '#4CAF50' : '#666' }}>
          {loading ? status || 'Processing...' : 'Ready'}
        </span>
      </div>
      <div style={{ 
        width: '100%', 
        backgroundColor: '#e0e0e0', 
        borderRadius: '5px',
        overflow: 'hidden'
      }}>
        <div style={progressBarStyle}>
          <span style={{
            position: 'absolute',
            right: '5px',
            color: 'white',
            fontSize: '12px',
            lineHeight: '20px'
          }}>
            {progress}%
          </span>
        </div>
      </div>
      {loading && (
        <div style={{ marginTop: '10px', fontSize: '14px', color: '#666' }}>
          <p style={{ margin: '5px 0' }}>{status}</p>
        </div>
      )}
    </div>
  );
};

export default ProgressBar;
